import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  Center,
  FormControl,
  FormLabel,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Select,
  ModalFooter,
  VStack,
  Text,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchEducationCourseAsync,
  selectJobEducationCourse,
} from "../../../JobPostingSlice/JobEducationCourse/JobEducationCourceSlice";
import { useForm } from "react-hook-form";
import {
  fetchJobEducationAsync,
  selectJobEducation,
} from "../../../JobPostingSlice/JobEducation/JobEducationSlice";
import {
  addJobEducationCourseSpecialtyAsync,
  deleteJobEducationCourseSpecialtyAsync,
  fetchEducationCourseSpecialtyAsync,
  selectJobEducationCourseSpecialty,
  updateJobEducationCourseSpecialtyAsync,
} from "../../../JobPostingSlice/JobEducationCourseSpecialty/JobEducationCourseSpecialtySlice";

function JobEducationCourseSpecialty() {
  const dispatch = useDispatch();

  const jobEducationCourse = useSelector(selectJobEducationCourse);
  const jobEducation = useSelector(selectJobEducation);
  const specialty = useSelector(selectJobEducationCourseSpecialty);
  const [isLoading, setIsLoading] = useState(true);

  // console.log("courses", jobEducationCourse);

  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  // const [newJobEducationCourse, setNewJobEducationCourse] = useState("");
  // const [newJobStatus, setNewJobStatus] = useState(""); // Add status state
  const [error, setError] = useState(null);
  const [editJobEducationCourse, setEditJobEducationCourse] = useState("");
  const [editJobEducationCourseSpecialty, setEditJobEducationCourseSpecialty] =
    useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editJobStatus, setEditJobStatus] = useState("");
  const [editableJobEducationCourse, setEditableJobEducationCourse] =
    useState(null);
  const [deletingEducationCourse, setDeletingEducationCourse] = useState(null);

  // console.log("job education", jobEducation);

  useEffect(() => {
    dispatch(fetchJobEducationAsync());
    dispatch(fetchEducationCourseAsync());
    dispatch(fetchEducationCourseSpecialtyAsync());
  }, [dispatch]);

  const handleDelete = async (uuid) => {
    // console.log("uuid", uuid)
    await dispatch(deleteJobEducationCourseSpecialtyAsync(uuid));
    await dispatch(fetchEducationCourseSpecialtyAsync());
    onClose2();
  };

  const openDeleteModal = (job) => {
    setDeletingEducationCourse(job);
    dispatch(fetchEducationCourseAsync());
    onOpen2();
  };

  const handleSave = async (newJobEducationCourseSpecialty) => {
    try {
      // console.log("data", newJobEducationCourse);
      await dispatch(
        addJobEducationCourseSpecialtyAsync(newJobEducationCourseSpecialty)
      );
      await dispatch(fetchEducationCourseSpecialtyAsync());
      onClose1();
      reset();
    } catch (error) {
      console.error("Failed to add project", error);
    }
  };

  const handleEdit = (jobTitle) => {
   
    setEditableJobEducationCourse(jobTitle);
    setEditJobEducationCourse(jobTitle.title);
    setEditJobStatus(jobTitle.status);
    setEditJobEducationCourseSpecialty(jobTitle.core_job_education_course.uuid); // Ensure this is correctly set
    setIsEditModalOpen(true);
  };

  const handleUpdate = async () => {
    if (editJobEducationCourse.trim()) {
      try {
        await dispatch(
          updateJobEducationCourseSpecialtyAsync({
            uuid: editableJobEducationCourse.uuid,
            jobEducationCourseSpecialtyData: {
              title: editJobEducationCourse,
              status: editJobStatus, // Include status
              job_education_course_uuid: editJobEducationCourseSpecialty, // Include jobEducation selection
            },
          })
        );

        await dispatch(fetchEducationCourseSpecialtyAsync());
        setEditableJobEducationCourse(null);
        setEditJobEducationCourse("");
        setEditJobStatus(""); // Reset status
        setEditJobEducationCourseSpecialty(""); // Reset jobEducation selection
        setIsEditModalOpen(false);
      } catch (err) {
        setError(err.message);
      }
    }
  };

  return (
    <div
      className="h-screen bg-adminbg p-4 contentAdmin"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div>
        <div className="w-full my-5 bg-white rounded-md">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              Job Education Course Specialty List
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Button colorScheme="blue" fontSize="medium" onClick={onOpen1}>
                Add<i className="fa-solid fa-plus px-2"></i>
              </Button>

              {/* Add Job Modal */}
              <Modal isOpen={isOpen1} onClose={onClose1}>
                <ModalOverlay />
                <ModalContent maxW="2xl">
                  <div className="p-4">
                    <h4 className="py-2">
                      Add Job Education Course Specialty:
                    </h4>
                    <form onSubmit={handleSubmit(handleSave)}>
                      <Input
                        className="border-black"
                        placeholder="Enter Education Specialty"
                        {...register("title", { required: true })}
                      />
                      {errors.title && (
                        <p className="text-red-500">This field is required</p>
                      )}

                      <Input
                        className="border-black"
                        placeholder="Enter job status"
                        {...register("status", { required: true })}
                      />
                      {errors.status && (
                        <p className="text-red-500">This field is required</p>
                      )}

                      <Select
                        className="border-black"
                        placeholder="Select job education course"
                        {...register("job_education_course_uuid", {
                          required: true,
                        })}
                      >
                        {Array.isArray(jobEducationCourse) &&
                          jobEducationCourse.map((education) => (
                            <option key={education.id} value={education.uuid}>
                              {education.title}
                            </option>
                          ))}
                      </Select>
                      {errors.jobEducationCourse && (
                        <p className="text-red-500">This field is required</p>
                      )}

                      <div className="w-full flex justify-center gap-2 mt-5">
                        <Button
                          colorScheme="blue"
                          className="w-64"
                          type="submit"
                        >
                          Save
                        </Button>
                        <Button
                          colorScheme="blue"
                          variant="outline"
                          className="w-64"
                          onClick={onClose1}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </div>
                </ModalContent>
              </Modal>
            </div>
          </div>

          {/* Table Section */}
          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="w-1/4">Course</Th>
                  <Th className="w-1/4">Title</Th>
                  <Th className="w-1/4">Status</Th>
                  <Th className="w-1/4">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {specialty && specialty.length > 0 ? (
                  specialty.map((job) => (
                    <Tr key={job.id}>
                      <Td>{job?.core_job_education_course?.title}</Td>
                      <Td>{job.title}</Td>
                      <Td className="text-green-500">{job.status}</Td>
                      <Td>
                        <div className="text-sm opacity-90 text-blue-700 flex">
                          <button onClick={() => handleEdit(job)}>
                            <i className="fa-solid fa-pencil mr-3.5"></i>
                          </button>

                          {/* Edit Modal */}
                          <Modal
                            isOpen={isEditModalOpen}
                            onClose={() => setIsEditModalOpen(false)}
                          >
                            <ModalOverlay />
                            <ModalContent maxW="2xl">
                              <ModalHeader>
                                Edit Job Education Course Specialty
                              </ModalHeader>
                              <ModalCloseButton />
                              <ModalBody>
                                <VStack spacing={4} align="stretch">
                                  <FormControl>
                                    <FormLabel>Job Title</FormLabel>
                                    <Input
                                      className="border-black"
                                      placeholder="Enter Education Course title"
                                      value={editJobEducationCourse}
                                      onChange={(e) =>
                                        setEditJobEducationCourse(
                                          e.target.value
                                        )
                                      }
                                    />
                                  </FormControl>

                                  <FormControl>
                                    <FormLabel>Job Status</FormLabel>
                                    <Input
                                      className="border-black"
                                      placeholder="Enter job status"
                                      value={editJobStatus}
                                      onChange={(e) =>
                                        setEditJobStatus(e.target.value)
                                      }
                                    />
                                  </FormControl>

                                  <FormControl>
                                    <FormLabel>Job Education</FormLabel>
                                    <Select
                                      className="border-black"
                                      placeholder="Select job education"
                                      value={editJobEducationCourseSpecialty}
                                      onChange={(e) =>
                                        setEditJobEducationCourseSpecialty(
                                          e.target.value
                                        )
                                      }
                                    >
                                      {Array.isArray(jobEducationCourse) &&
                                        jobEducationCourse.map((education) => (
                                          <option
                                            key={education.uuid}
                                            value={education.uuid}
                                          >
                                            {education.title}
                                          </option>
                                        ))}
                                    </Select>
                                  </FormControl>
                                </VStack>
                                {error && <Text color="red.500">{error}</Text>}
                              </ModalBody>
                              <ModalFooter>
                                <Button
                                  colorScheme="blue"
                                  w="50%"
                                  onClick={handleUpdate}
                                >
                                  Update
                                </Button>
                                <Button
                                  colorScheme="blue"
                                  variant="outline"
                                  w="50%"
                                  onClick={() => setIsEditModalOpen(false)}
                                >
                                  Cancel
                                </Button>
                              </ModalFooter>
                            </ModalContent>
                          </Modal>

                          {/* Delete Modal */}
                          <button onClick={() => openDeleteModal(job)}>
                            <i className="cursor-pointer fa-solid fa-trash-can-arrow-up mr-3.5"></i>
                          </button>
                          <Modal isOpen={isOpen2} onClose={onClose2}>
                            <ModalOverlay />
                            <ModalContent maxW="2xl">
                              <div className="p-4">
                                <h4 className="py-2">
                                  Are you sure you want to delete "
                                  {deletingEducationCourse?.title}"?
                                </h4>
                                <div className="w-full flex justify-center gap-2 mt-4">
                                  <Button
                                    colorScheme="red"
                                    className="w-48"
                                    onClick={() =>
                                      handleDelete(deletingEducationCourse.uuid)
                                    }
                                  >
                                    Delete
                                  </Button>
                                  <Button
                                    colorScheme="red"
                                    variant="outline"
                                    className="w-48"
                                    onClick={onClose2}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </div>
                            </ModalContent>
                          </Modal>
                        </div>
                      </Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan="4" className="text-center py-4">
                      No data available
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default JobEducationCourseSpecialty;
